import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const carouselSlideInFn = /* @__PURE__ */ createRecipe('carousel-slide-in', {}, [])

const carouselSlideInVariantMap = {}

const carouselSlideInVariantKeys = Object.keys(carouselSlideInVariantMap)

export const carouselSlideIn = /* @__PURE__ */ Object.assign(memo(carouselSlideInFn.recipeFn), {
  __recipe__: true,
  __name__: 'carouselSlideIn',
  __getCompoundVariantCss__: carouselSlideInFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: carouselSlideInVariantKeys,
  variantMap: carouselSlideInVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, carouselSlideInVariantKeys)
  },
  getVariantProps: carouselSlideInFn.getVariantProps,
})